// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"32":"misc","296":"privacy","328":"admin","893":"products"}[chunkId] || chunkId) + "." + {"32":"7bd0e767","296":"2797ba5b","328":"a83d2bdb","893":"8186b2ca","985":"052ef742"}[chunkId] + ".css";
};